import o from "./ghl-ui.es1486.js";
import a from "./ghl-ui.es1480.js";
import i from "./ghl-ui.es1487.js";
function f(r) {
  return a(r) ? i(r) : o(r);
}
export {
  f as default
};
